import React, {  Component } from 'react';
// import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';


import { connect } from 'react-redux';

class ChangeCamModal extends Component {

    constructor(props){
        super(props);
        this.state={

        }
    }
   
    closeModal() {
        this.props.setChangeCamModal(false);
    }

    change_device(event) {
        this.props.mudarDevices({deviceMicSelect:this.props.deviceMicSelect, deviceCamSelect: event.target.value })

        // console.log(event);
        localStorage.setItem("deviceId", event.target.value);
        this.props.handleEnableVideoStream(true)

        
    }

    change_device_mic(event) {
        this.props.mudarDevices({deviceCamSelect:this.props.deviceCamSelect, deviceMicSelect: event.target.value })

        // console.log(event);
        localStorage.setItem("deviceIdMic", event.target.value);

        this.props.handleEnableAudioStream(true)
    }
    


    

    render() {

        return (
            <div>
                {/* <Button color="danger" onClick={toggle}>{buttonLabel}</Button> */}
                <Modal show={this.props.change_cam_modal} onHide={this.closeModal.bind(this)}  >
                    <Modal.Header closeButton={false}><Modal.Title>Escolher câmera</Modal.Title></Modal.Header>
                    <Modal.Body>
                        <div className="form-group">
                             <p style={{marginTop:5,marginBottom:0}}><b>Câmera: </b></p>
                                                        <select value={this.props.deviceCamSelect} className="form-control" id="cameras" onChange={this.change_device.bind(this)}>
                                                            {this.props.devicesCam.map((item, id) => (
                                                                <option key={id} value={item.deviceId}>{item.label}</option>

                                                            ))}
                                                        </select>
                                                        <p style={{marginTop:5,marginBottom:0}}><b>Microfone: </b></p>

                                                        <select value={this.props.deviceMicSelect} className="form-control" id="mics" onChange={this.change_device_mic.bind(this)}>
                                                            {this.props.devicesMic.map((item, id) => (
                                                                <option key={id} value={item.deviceId}>{item.label}</option>

                                                            ))}
                                                        </select>
                        </div>

                    </Modal.Body>
                    <Modal.Footer>
                        {/* <Button color="primary" onClick={this.change_device.bind(this)}>Alterar</Button>{' '} */}
                        <Button color="secondary" onClick={this.closeModal.bind(this)}>Fechar</Button>
                    </Modal.Footer>
                </Modal>
            </div>
        );
    }

}

const mapsStateToProps = (state) => (
    {
      
    }
);

export default connect(mapsStateToProps, { })(ChangeCamModal);